var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-page"},[_c('div',{staticClass:"video"},[_c('InlineVideo',{attrs:{"video":_vm.post.acf.video,"subtitles":_vm.post.acf.subtitles,"image":_vm.post.acf.video_placeholder,"showControls":true}})],1),_c('PageDescription',{attrs:{"post":_vm.post}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }